module.exports = __webpack_public_path__ + "img/353.15af2802.jpg";